export const application = 'bright-preprod';

export const apiURL = '/bright/api';

export const rootUrl = 'https://admin-preprod.learnwithbright.com';

export const vimeoClientId = '15a9673c81d2f261fca256dcabec4c439e215a55';

export const vimeoRedirect = 'https://admin-preprod.learnwithbright.com/bright/api/vimeo/callback';

export const academyURL = 'https://app-preprod.learnwithbright.academy';
